export class LegAirportChanges {
  originIcaoCode: string = null;
  destinationIcaoCode: string = null;
  originIcaoChanged: boolean = false;
  destinationIcaoChanged: boolean = false;
  originAirportTimezoneAbbr: string = null;
  departureTime: Date = null;
  departureTimeChanged: boolean = false;
}
